module.exports = __webpack_public_path__ + "static/media/TRIAL-2-if-correct-kopi.26a5fe39.mp3";